export default __webpack_public_path__ + "static/media/verified_icon.db95d8b7.svg";